module.exports = __webpack_public_path__ + "img/logo-apple-touch-72.231352e0.png";